import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../sidebar/sidebar";

const AppLayout = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const currentPath = location.pathname.split('/')[1] || "Dashboard";
    return (
        <div className="flex w-full">
            <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />

            <div
                className={`transition-all duration-300 flex-1 overflow-y-auto bg-gray-100 ${isOpen ? "md:ml-64" : "md:ml-16"} ml-16`}
            >
                <header className="fixed w-full top-0 bg-primary border-b border-blue-600 text-white shadow-md p-4 z-40">
                    <div className="mx-auto flex items-center justify-between">
                        <h1 className="text-xl font-bold">{currentPath.toLocaleUpperCase()}</h1>

                    </div>
                </header>
                <div className="pt-12">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default AppLayout;